import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Container, Link } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import DetailsUserForm from "./detailsUserForm";
import { useLocation, useParams } from "react-router-dom";
import { userData } from "../../data/userData";
import { Link as RouterLink } from "react-router-dom";

const CreateUserContainer = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mode, setMode] = useState("view");

  useEffect(() => {
    if (location.pathname.includes("edit-user")) {
      setMode("edit");
    } else if (location.pathname.includes("view-user")) {
      setMode("view");
    } else {
      setMode("create");
    }
  }, [location.pathname]);

  console.log("mode:", mode, "id:", id);
  const userDetails = userData.find((u) => u.id === Number(id));
  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/user" underline="hover" color="primary.main">
                  User Management
                </Link>
              }
              second={
                mode === "view"
                  ? "View User"
                  : mode === "edit"
                  ? "Edit User"
                  : "Add User"
              }
            />

            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>

        <Box sx={{ width: "100%" }}>
          <DetailsUserForm
            mode={mode}
            userDetails={userDetails}
            onModeChange={setMode}
          />
        </Box>
      </Box>
    </PrivateLayout>
  );
};

export default CreateUserContainer;
